module.exports = __webpack_public_path__ + "static/media/opevoLogo.20f2aff7.png";